import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts';
import { api } from '../services/api';
import { toast } from './ui/Toast/Toast';

const EXPIRY_WINDOW_DAYS = 7;

/**
 * Mostra um toast de vencimento assim que o usuário entra, quando faltam <= 7 dias.
 * Se a assinatura for PIX, o toast vira um deeplink para Configurações > Assinatura
 * (onde fica o botão "Gerar pagamento"). Mostra no máximo uma vez por sessão.
 */
export function SubscriptionExpiryToast() {
    const { isAuthenticated, isAdmin, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated || isAdmin || !user || user.status !== 'active') return;

        const guardKey = `expiry-toast-shown:${user.id}`;
        if (sessionStorage.getItem(guardKey)) return;

        let cancelled = false;
        api.getMySubscriptionStatus()
            .then((s) => {
                if (cancelled) return;
                if (!s.hasSubscription || s.status !== 'ACTIVE') return;

                const days = s.daysUntilExpiry;
                if (days == null || days < 0 || days > EXPIRY_WINDOW_DAYS) return;

                // Marca só ao efetivamente exibir (depois do fetch) — evita o efeito
                // do StrictMode cancelar a 1ª execução e a 2ª pular por guard já setado.
                sessionStorage.setItem(guardKey, '1');

                const prazo = days === 0 ? 'hoje' : `em ${days} dia${days === 1 ? '' : 's'}`;

                if (s.paymentMethod === 'pix') {
                    toast(
                        `Sua assinatura expira ${prazo}. Toque para gerar o pagamento via PIX.`,
                        'info',
                        { onClick: () => navigate('/settings?tab=subscription') },
                    );
                } else {
                    toast(`Sua assinatura expira ${prazo}. Fique atento à renovação.`, 'info');
                }
            })
            .catch(() => { });

        return () => { cancelled = true; };
    }, [isAuthenticated, isAdmin, user, navigate]);

    return null;
}
